import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import jwt_decode from "jwt-decode";
import { AuthenticationService } from '../../core/services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UsersRoleService } from '../user-role/users-role.service';
import { LoginapiService } from '../../auth/loginapi.service';
import { FleetService } from 'src/app/pages/managefleets/fleet-service/fleet.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DomSanitizer } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})

export class TopbarComponent implements OnInit {
  selectedType: any;
  loginUserDetail: any
  loginUser: any;
  enable: boolean = true;
  disable:boolean = true;
  mainData: boolean = true;
  user: any;
  multiRoles: any;
  userRoleResponse: any;
  loginResponse: any;
  dataLoginName: any;
  selectUserData:any =[]
  consumerData:any = {
  opentype:[{name:'A***a',value:'Azuga'},{name:'R*******m',value:'IMT Insurance'},{name:'Bl*******y',value:'Blackberry'},{name:'Pi****r',value:'Pioneer'},{name:'A***m',value:'Axiom'},{name:'C*******h',value:'Clearpath'},{name:'I***x',value:'Inrix'}],
  provider:[{name:'S******s',value:'stellantis'},{name:'F**d',value:'ford'},{name:'T*****a',value:'toyota'},{name:'N*****n',value:'nissan'},{name:'V********e',value:'voyomotive'}],
}
  userDash: any;
  changeRole: boolean;
  customConsumer: any;
  imageUrl: any;
  preview: any;
  constructor(@Inject(DOCUMENT) private document: any, private loginapiservice: LoginapiService, 
  private modalService: NgbModal, private _userRole: UsersRoleService, public router: Router, private authService: AuthenticationService,private fleetService:FleetService,private spinner:NgxSpinnerService,
  private sanitizer: DomSanitizer,private toastr : ToastrService) { 
        this.getLogo()
  }
  openMobileMenu: boolean;
  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();
  selectedImage: any = null;

  goToReport() {
    this.router.navigate(['/adlp/report/inactivity-report']);
}
  ngOnInit() {
    this.openMobileMenu = false;
    this.loginUserDetail = sessionStorage.getItem('user-token');
    this.showRole();
    this.decodeToken()
  }

  // onFileSelected(event: any): void {
  //   const file = event.target.files[0];

  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //       this.selectedImage = e.target?.result;
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // }

getLogo() {
  this.spinner.show();

  this.fleetService.getImage().subscribe(
    (res: any) => {

      const result = res;
      const currentUrl = window.location.hostname.toLowerCase();

      if (currentUrl === 'clearpath.fleetready.ai') {
        this.imageUrl = './assets/images/clearPath.png';
      }
      else if (currentUrl === 'titan.fleetready.ai') {
        this.imageUrl = './assets/images/TitanGps.png';
      }
      
      else {
        this.imageUrl = result?.logoUrl;
      }

      setTimeout(() => {
        this.spinner.hide();
      }, 1000);
    },
    err => {
      this.spinner.hide();
    }
  );
}

  closeModal() {
    this.preview = null;
    this.selectedImage = null
  }

  onFileSelected(event: any): void {
    const files1 = event.target.files;
    if (files1.length > 0) {
      let file: File = event.target.files.item(0);
        this.selectedImage =file
        console.log(this.selectedImage,'imagegge')
        const reader = new FileReader();

      reader.onload = (e: any) => {
        console.log(e.target.result);
        this.preview = e.target.result;
        this.preview = this.sanitizer.bypassSecurityTrustUrl(this.preview)
      };

      reader.readAsDataURL(this.selectedImage);
    }
  }

  requestSent(deleteConsumerData) {
    if(this.user != "role_consumer") {
      this.modalService.open(deleteConsumerData, { size: 'sx', centered: true });

    }    
  }

  changeLogo() {
    this.spinner.show()
    this.fleetService.uploadImage(this.selectedImage).subscribe((res:any)=>{
      this.selectedImage = null
      this.preview = null;
      this.getLogo()
      this.spinner.hide()
    },err=>{
      this.toastr.error(err.error.apierror.message)
      this.spinner.hide()
    })
  }


  showRole() {
    let userRolLogin = JSON.stringify(sessionStorage.getItem('userRole'));
    this.user = JSON.parse(userRolLogin);
    console.log(this.user,'userr')
    let tspuserData = JSON.parse(sessionStorage.getItem('Useremail'))
    let tspEmail = tspuserData?.email
    if (tspEmail == 'smccurdy@hdfleet.com') {
      this.enable = true
      this.disable = false;
      this.mainData = false;
    }
    else if(tspEmail == 'adam@onestepgps.com'){
      this.disable = true;
      this.enable = false;
      this.mainData = false
    }
    else{
      this.disable = false;
      this.enable = false;
      this.mainData = true;
    }
    this.multiRoles = JSON.parse(sessionStorage.getItem('multiRole'));
    let customConsumers =JSON.stringify(sessionStorage.getItem('custom-consumer'));
    this.customConsumer=JSON.parse(customConsumers); 
  }

  openModal(content: any) {
    this.modalService.open(content);
  }

  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  logout() {
    let userdata = JSON.parse(this.loginUserDetail);
    let token = userdata.accessToken;
    const logoutToken: any = {
      accessToken: token
    }
    this.authService.logOut(logoutToken);
  }
  decodeToken() {
    var userdetail = JSON.parse(this.loginUserDetail)
    if (userdetail)
      var token = userdetail.idToken;
    this.loginUser = jwt_decode(token);
  }

  datapihub() {
    this.router.navigate(['adlp/developer-corner/dataapihub']);
  }

  cxtaxonomy() {
    this.router.navigate(['adlp/developer-corner/cerebrumx-taxonomy'])
  }

  createcustommodel() {
    this.router.navigate(['adlp/developer-corner/custom-model'])
  }

  vindecoder(){
    this.router.navigate(['adlp/developer-corner/generatereports'])
  }

  tripsimulator(){
    this.router.navigate(['adlp/developer-corner/trip-simulator'])
  }

  configuration(){
    this.router.navigate(['adlp/insurance/configuration'])
  }

  onChange(event) {
    this.selectedType = event.target.value;
    if(this.selectedType == 'provider') {
      this.changeRole = true;
      this.selectUserData = this.consumerData.provider
    } else if(this.selectedType == 'admin') {
      this.changeRole = false;
      this.selectUserData = this.consumerData.admin
    } else {
      this.changeRole = true;
      this.selectUserData = this.consumerData.opentype
    }
  }

  support(){
    this.router.navigate(['adlp/support'])
  }


  selectDashboard(evt) {
    this.userDash = evt;
  }
  
  submit() {
    if(this.userDash == 'IMT Insurance') {
      sessionStorage.setItem('custom-consumer', 'IMT Insurance')
      sessionStorage.setItem('custom-changeConsumer','IMT Insurance')
      sessionStorage.setItem('userRole', 'role_consumer')
      this.router.navigate(['adlp'])
      this.authService.sendDataToChildComponent('IMT Insurance')
    }
    else if (this.userDash == 'Azuga') {
      sessionStorage.setItem('custom-consumer', 'Azuga')
      sessionStorage.setItem('custom-changeConsumer','Azuga')
      sessionStorage.setItem('userRole', 'role_consumer')
      this.authService.sendDataToChildComponent('Azuga')
      this.router.navigate(['adlp/dashboard/fleet'])
    }
    else if (this.userDash == 'Axiom') {
      sessionStorage.setItem('custom-consumer', 'Azuga')
      sessionStorage.setItem('custom-changeConsumer','Axiom')
      sessionStorage.setItem('userRole', 'role_consumer')
      this.authService.sendDataToChildComponent('Azuga')
      this.router.navigate(['adlp/dashboard/default/consumer-axiom'])
    }

    else if (this.userDash == 'Inrix') {
      sessionStorage.setItem('custom-consumer', 'Azuga')
      sessionStorage.setItem('custom-changeConsumer','Inrix')
      sessionStorage.setItem('userRole', 'role_consumer')
      this.authService.sendDataToChildComponent('Azuga')
      this.router.navigate(['adlp/dashboard/default/consumer-inrix'])
    }

    else if (this.userDash == 'Clearpath') {
      sessionStorage.setItem('custom-consumer', 'Azuga')
      sessionStorage.setItem('custom-changeConsumer','Clearpath')
      sessionStorage.setItem('userRole', 'role_consumer')
      this.authService.sendDataToChildComponent('Azuga')
      this.router.navigate(['adlp/dashboard/default/consumer-clearpath'])
    }

    else if (this.userDash == 'Geico') {
      sessionStorage.setItem('custom-consumer', 'IMT Insurance')
      sessionStorage.setItem('custom-changeConsumer','Geico')
      sessionStorage.setItem('userRole', 'role_consumer')
      this.authService.sendDataToChildComponent('IMT Insurance')
      this.router.navigate(['adlp/dashboard/default/geico'])
    }

    else if (this.userDash == 'Blackberry') {
      sessionStorage.setItem('custom-consumer', 'Blackberry')
      sessionStorage.setItem('custom-changeConsumer','Blackberry')
      sessionStorage.setItem('userRole', 'role_consumer')
      this.authService.sendDataToChildComponent('Blackberry')
      this.router.navigate(['adlp/dashboard/blackberry'])
    }

    else if (this.userDash == 'Pioneer') {
      sessionStorage.setItem('custom-consumer', 'Pioneer')
      sessionStorage.setItem('custom-changeConsumer','Pioneer')
      sessionStorage.setItem('userRole', 'role_consumer')
      this.authService.sendDataToChildComponent('Pioneer')
      this.router.navigate(['adlp/dashboard/blackberry'])
    }

    else if (this.userDash == 'Encova') {
      sessionStorage.setItem('custom-consumer', 'IMT Insurance')
      sessionStorage.setItem('custom-changeConsumer','Encova')
      sessionStorage.setItem('userRole', 'role_consumer')
      this.authService.sendDataToChildComponent('IMT Insurance')
      this.router.navigate(['adlp/dashboard/default/encova'])
    }
    else if (this.userDash == 'stellantis') {
      sessionStorage.setItem('custom-consumer', 'stellantis')
      sessionStorage.setItem('userRole', 'role_provider')
      this.router.navigate(['adlp/provider'])
      this.authService.sendDataToChildComponent('provider')
    }

    else if (this.userDash == 'nissan') {
      sessionStorage.setItem('custom-consumer', 'nissan')
      sessionStorage.setItem('userRole', 'role_provider')
      this.router.navigate(['adlp/dashboard/provider/provider-nissan'])
      this.authService.sendDataToChildComponent('provider')
    }

    else if (this.userDash == 'ford') {
      sessionStorage.setItem('custom-consumer', 'ford')
      sessionStorage.setItem('userRole', 'role_provider')
      this.router.navigate(['adlp/dashboard/provider/provider-ford'])
      this.authService.sendDataToChildComponent('provider')
    }

    else if (this.userDash == 'toyota') {
      sessionStorage.setItem('custom-consumer', 'toyota')
      sessionStorage.setItem('userRole', 'role_provider')
      this.router.navigate(['adlp/dashboard/provider/provider-toyota'])
      this.authService.sendDataToChildComponent('provider')
    }

    else if (this.userDash == 'voyomotive') {
      sessionStorage.setItem('custom-consumer', 'voyomotive')
      sessionStorage.setItem('userRole', 'role_provider')
      this.router.navigate(['adlp/dashboard/provider/provider-voyomotive'])
      this.authService.sendDataToChildComponent('provider')
    }

    else if (this.selectedType == 'admin') {
      sessionStorage.setItem('userRole', 'admin')
      this.router.navigate(['adlp/admin'])
      this.authService.sendDataToChildComponent('admin')
    }
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

  }
}
